import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  DialogClose,
} from "@/components/shadcn/dialog";
import { UIButton } from "@/components/ui/button";
import { EbaRetailTable } from "./eba-retail-table";
import { useDict } from "../../../app/[lang]/providers/DictionaryProvider";

interface DialogEbaRetailProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  funds: string;
  coupon: number | null;
  onShowResult: () => void;
}

export function DialogEbaRetail({ open, onOpenChange, funds, coupon, onShowResult }: DialogEbaRetailProps) {
  const dict = useDict();
  const n = 4; // 4 periode (kuartal)
  const nominal = Number(funds) || 0;
  const r = coupon ? coupon / 100 / 4 : 0; // kupon per periode
  // 1. Lump Sum: bunga per periode dibulatkan sebelum dijumlahkan, pokok keluar dibulatkan per periode
  let lumpSum = 0;
  let Ik = nominal;
  const alpha = 0.1;
  for (let k = 0; k < n; k++) {
    const bunga = Math.round(r * Ik);
    lumpSum += bunga;
    const pokokKeluar = Math.round(alpha * Ik);
    Ik = Ik - pokokKeluar;
  }
  // 2. Reinvestasi Pokok: bunga per periode dibulatkan sebelum dijumlahkan
  let reinvestPokok = 0;
  for (let k = 0; k < n; k++) {
    reinvestPokok += Math.round(r * nominal);
  }
  // 3. Reinvestasi Pokok+Bunga: bunga per periode dibulatkan sebelum dijumlahkan
  let reinvestPokokBunga = 0;
  Ik = nominal;
  for (let k = 0; k < n; k++) {
    const bunga = Math.round(r * Ik);
    reinvestPokokBunga += bunga;
    Ik = Ik + bunga;
  }
  const totalBunga = [lumpSum, reinvestPokok, reinvestPokokBunga];
  const ipr = totalBunga.map(x => nominal > 0 ? (x / nominal * 100).toFixed(2) + " %" : "-");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton className="sm:max-w-[900]">
        <DialogHeader>
          <DialogTitle>{dict.ebaRetail.title} {dict.ebaRetail.calculationResultTitle}</DialogTitle>
          <DialogDescription>
            {dict.ebaRetail.calculationResultDesc}
          </DialogDescription>
        </DialogHeader>
        <div className="my-4">
          <EbaRetailTable totalBunga={totalBunga} ipr={ipr} />
        </div>
        <DialogFooter className="flex justify-between w-full">
          <DialogClose asChild>
            <div className="flex justify-between gap-2 w-full">
              <span className="text-sm text-muted-foreground italic">{dict.ebaRetail.disclaimer}</span>
              <UIButton variant="default" onClick={onShowResult} className=" text-white">{dict.ebaRetail.showCalculation}</UIButton>
            </div>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
